// src/components/PublicRoute.js
import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { Web3Context } from '../context/Web3Context';

const PublicRoute = ({ component: Component }) => {
    const { account } = useContext(Web3Context);
    const isAuthenticated = !!account; // Check authentication status

    return  <Component /> ;
};

export default PublicRoute;
